module.exports = __webpack_public_path__ + "static/media/white-logo-clock-in-1p5.92e695b1.png";